const WayFinderTenantListing = () => import('../../components/WayFinder/Tenant/List')
const WayFinderTenantManage = () => import('../../components/WayFinder/Tenant/Manage')

export default {
    path: 'wayfinder-tenants',
    redirect: 'wayfinder-tenants',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'wayfinder-tenants',
    meta: {'permissions': 'view-wayfinder-tenants'},
    children: [
        {
            path: '/',
            component: WayFinderTenantListing,
        },
        {
            path: 'create',
            name: 'create-wayfinder-tenant',
            meta: {'permissions': 'create-wayfinder-tenant'},
            component: WayFinderTenantManage,
        },
        {
            path: 'update/:id',
            name: 'update-wayfinder-tenant',
            meta: {'permissions': 'update-wayfinder-tenant'},
            component: WayFinderTenantManage,
        },
    ],
};
